export enum ErrorCode {
    NOT_FOUND = 404,
    NOT_AUTHORIZED = 401,
    FORBIDDEN = 403,
}
